// Denaakke Kids Zone
// Also covers Benhti (Minto) via secondary Firebase project
// See Stage 1 in CLAUDE.md for dual Firebase architecture details

const AppName = "Denaakk'e Kids Zone";
const Language = "Denaakk'e";
const Tribe = "Denaakk'e";

const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_DENAAKKE,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DENAAKKE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_DENAAKKE, // denaakke-6642e
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DENAAKKE,
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DENAAKKE,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_DENAAKKE,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DENAAKKE,
};

// Benhti (Minto) secondary Firebase project
const SecondaryFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_BENHTI,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_BENHTI,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_BENHTI, // benhti-7e074
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_BENHTI, // benhti-media
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_BENHTI,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_BENHTI,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_BENHTI,
};

const FilePath = "https://storage.googleapis.com/denaakke-media/";
const SecondaryFilePath = "https://storage.googleapis.com/benhti-media/";
const NacaApiUrl = process.env.REACT_APP_NACA_API_URL || "https://naca.community";
const NacaCommunityId = "aeb63fa3-5d06-4c8c-90b6-5542c7bdbe77";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "vocabData" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_GameFilterDataNew", nameToSave: "gameData" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
];

const ParamsToFindGame = [
  { data: "category", param: "unit" },
  { data: "target", param: "game-name" },
  { data: "gameType", param: "game-type" },
];

const NumberDataCategory = "How Many Are There? 1";

const BottomColor = "rgba(247,148,29,1)";

const VersionNumber = "2.00.00000";

// Location/town selection is required for Denaakke -- see Stage 2
// 13 towns, each with a dialect priority chain
const hasLocationSelection = true;
const dialectStructure = [
  {
    display: "Hughes",
    code: "DC",
    structure: [
      { Key: 0, code: "DC" },
      { Key: 1, code: "KR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Huslia",
    code: "DC",
    structure: [
      { Key: 0, code: "DC" },
      { Key: 1, code: "KR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Allakaket",
    code: "DC",
    structure: [
      { Key: 0, code: "DC" },
      { Key: 1, code: "KR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Alatna",
    code: "AET",
    structure: [
      { Key: 0, code: "AET" },
      { Key: 1, code: "DC" },
      { Key: 2, code: "KR" },
      { Key: 3, code: "DS" },
    ],
  },
  {
    display: "Ruby",
    code: "DC",
    structure: [
      { Key: 0, code: "DC" },
      { Key: 1, code: "YR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Koyukuk",
    code: "DC",
    structure: [
      { Key: 0, code: "DC" },
      { Key: 1, code: "YR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Nulato",
    code: "NUL",
    structure: [
      { Key: 0, code: "NUL" },
      { Key: 1, code: "DL" },
      { Key: 2, code: "YR" },
      { Key: 3, code: "DS" },
    ],
  },
  {
    display: "Kaltag",
    code: "KAL",
    structure: [
      { Key: 0, code: "KAL" },
      { Key: 1, code: "DL" },
      { Key: 2, code: "YR" },
      { Key: 3, code: "DS" },
    ],
  },
  {
    display: "Tanana",
    code: "DU",
    structure: [
      { Key: 0, code: "DU" },
      { Key: 1, code: "YR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Rampart",
    code: "DU",
    structure: [
      { Key: 0, code: "DU" },
      { Key: 1, code: "YR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Manley",
    code: "DU",
    structure: [
      { Key: 0, code: "DU" },
      { Key: 1, code: "YR" },
      { Key: 2, code: "DS" },
    ],
  },
  {
    display: "Galena",
    code: "DC",
    structure: [
      { Key: 0, code: "DC" },
      { Key: 1, code: "YR" },
      { Key: 2, code: "DS" },
    ],
  },
  { display: "Minto", code: "Benhti", structure: [{ Key: 0, code: "Benhti" }] }, // Benhti -- switches to secondary Firebase
];

const PossibleGames = [
  "Bubble Pop",
  "Counting",
  "Good Guess",
  "Matching",
  "Whack-A-Mole",
  "Word To Image",
  "Verb Activity",
  "Wordless",
];

const Credits = {
  credits: [
    "Website created and designed through Native Teaching Aids LLC by Thomas Koefod and Spencer Kittle",
  ],
  links: [
    {
      link: "https://www.nativeteachingaids.com",
      image: "ntalogo.png",
      style: "short",
    },
  ],
};

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  SecondaryFirebaseConfig,
  FilePath,
  SecondaryFilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
  hasLocationSelection,
  dialectStructure,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  SecondaryFirebaseConfig,
  FilePath,
  SecondaryFilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
  hasLocationSelection,
  dialectStructure,
};
